import { useTheme } from '@mui/material'
import type { Plataforma } from '../../api/trafegoPago'

/**
 * Cor de cada plataforma — a mesma em todo gráfico, e ela não muda quando um filtro
 * tira a outra plataforma da tela (cor segue a entidade, nunca a posição).
 *
 * Slots 1 e 2 da paleta categórica de referência (skill dataviz), passos claro e escuro.
 * Validado em 23/09/2026 com validate_palette.js contra os fundos reais dos temas:
 * #ffffff (claros), #1e1e1e (Financial Dark) e #1A1424 (Exponential) — todos os
 * testes passam, incluindo separação para daltonismo (ΔE ≥ 24) e contraste ≥ 3:1.
 */
const CORES: Record<'light' | 'dark', Record<Plataforma, string>> = {
  light: { meta_ads: '#2a78d6', google_ads: '#eb6834' },
  dark: { meta_ads: '#3987e5', google_ads: '#d95926' },
}

export function useCoresPlataforma(): Record<Plataforma, string> {
  return CORES[useTheme().palette.mode]
}

/**
 * Cor de gráfico com uma série só (orgânico). Slot 3 da paleta (verde-água): validado
 * junto com as duas cores de plataforma em todos os pares, nos dois modos, então não se
 * confunde com Meta nem Google se um dia aparecerem lado a lado. As cores de gráfico dos
 * temas não servem aqui: o teal do tema padrão e o azul do Financial Dark falham no
 * validador. No claro fica em 2,82:1 de contraste — aceito porque todo gráfico tem
 * versão em tabela.
 */
const SERIE_UNICA: Record<'light' | 'dark', string> = { light: '#1baf7a', dark: '#199e70' }

export function useCorSerieUnica(): string {
  return SERIE_UNICA[useTheme().palette.mode]
}

export type Rede = 'instagram' | 'facebook' | 'tiktok'

/**
 * Cor de cada rede social. Os três primeiros slots da paleta, os únicos que passam o
 * validador em TODOS os pares nos dois modos (23/09/2026). Magenta para o Instagram foi
 * testado e falhou no escuro: para daltônicos vermelho-verde fica igual ao verde-água
 * (ΔE 1,6). São os mesmos tons do tráfego pago, mas em outro painel e sempre com legenda.
 */
const CORES_REDE: Record<'light' | 'dark', Record<Rede, string>> = {
  light: { facebook: '#2a78d6', instagram: '#eb6834', tiktok: '#1baf7a' },
  dark: { facebook: '#3987e5', instagram: '#d95926', tiktok: '#199e70' },
}

export function useCoresRede(): Record<Rede, string> {
  return CORES_REDE[useTheme().palette.mode]
}
